import React from 'react';
import './ServicePage.css';

const HomeInsurance = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>🏠 Konut Sigortası</h1>
          <p>Evinizi ve eşyalarınızı koruyun</p>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <section className="service-section">
            <h2>Konut Sigortası Nedir?</h2>
            <p>
              Konut sigortası, evinizi ve içindeki eşyalarınızı yangın, hırsızlık, 
              su baskını gibi risklere karşı koruyan sigorta türüdür. Evinizin 
              değerini ve eşyalarınızı güvence altına alır.
            </p>
          </section>

          <section className="service-section">
            <h2>Kapsamı</h2>
            <ul className="service-list">
              <li>Yangın ve patlama</li>
              <li>Hırsızlık ve gasp</li>
              <li>Su baskını ve sel</li>
              <li>Fırtına ve dolu</li>
              <li>Cam kırılması</li>
              <li>Üçüncü şahıs sorumluluğu</li>
            </ul>
          </section>

          <section className="service-section">
            <h2>Avantajları</h2>
            <ul className="service-list">
              <li>Evinizi ve eşyalarınızı korur</li>
              <li>Beklenmedik masraflardan korur</li>
              <li>Hızlı hasar tespit ve ödeme</li>
              <li>Esnek teminat seçenekleri</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HomeInsurance;

